// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
import { Cookies } from 'react-cookie';

const { publicRuntimeConfig } = getConfig();
const { env: environment, sentry } = publicRuntimeConfig || {};
const { dsn, tracesSampleRate } = sentry || {};

if (dsn && environment !== 'development') {
  let tycid = '';
  let userInfo;
  try {
    const cookies = new Cookies();
    const getUserInfo = () => {
      const { mobile, state, vipManager } = cookies.get('tyc-user-info') || {};
      // state >= 3 -----> 个人VIP，其他值：不是个人VIP用户
      // vipManager: 1 --> 企业VIP，其他值：不是企业VIP
      // isExpired > 0 --> 过期 VIP 用户
      return mobile
        ? {
          id: parseInt(mobile, 10).toString('16'),
          isVip: state >= 3,
          isEntVip: vipManager === 1,
        }
        : null;
    };
    tycid = cookies.get('TYCID') || '';
    userInfo = getUserInfo();
  } catch (e) {
    // do nothing
  }

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: +(tracesSampleRate || 0),
    initialScope: {
      tags: { tycid },
      ...(userInfo ? { user: userInfo } : null),
    },
  });
}
